import { buildModelManager } from "../builder.js";
const DefaultCustomerConnectorImportSelection = {
  __typename: true,
  id: true,
  archiveDirectory: true,
  connectorId: true,
  createdAt: true,
  csvDelimiter: true,
  customerId: true,
  filePrefix: true,
  isActive: true,
  lastError: true,
  lastRunAt: true,
  lastStatus: true,
  sourceDirectory: true,
  updatedAt: true
};
const modelApiIdentifier = "customerConnectorImport";
const pluralModelApiIdentifier = "customerConnectorImports";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCustomerConnectorImportSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCustomerConnectorImport",
    operationReturnType: "CreateCustomerConnectorImport",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      customerConnectorImport: { required: false, type: "CreateCustomerConnectorImportInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCustomerConnectorImports",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateCustomerConnectorImportsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "action",
    operationName: "updateCustomerConnectorImport",
    operationReturnType: "UpdateCustomerConnectorImport",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      customerConnectorImport: { required: false, type: "UpdateCustomerConnectorImportInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCustomerConnectorImports",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateCustomerConnectorImportsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "action",
    operationName: "deleteCustomerConnectorImport",
    operationReturnType: "DeleteCustomerConnectorImport",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCustomerConnectorImports",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCustomerConnectorImport",
    operationReturnType: "UpsertCustomerConnectorImport",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      customerConnectorImport: { required: false, type: "UpsertCustomerConnectorImportInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCustomerConnectorImportResult": { hasReturnType: false },
      "... on UpdateCustomerConnectorImportResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCustomerConnectorImports",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertCustomerConnectorImportsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCustomerConnectorImportSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "customerConnectorImportGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CustomerConnectorImportManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCustomerConnectorImportSelection,
  operations
);
export {
  CustomerConnectorImportManager,
  DefaultCustomerConnectorImportSelection
};
//# sourceMappingURL=CustomerConnectorImport.js.map
